import { Avatar } from './avatar';
import { EntityTypes, SRMStatus, SupplierVettingStatus } from './enums';
import { SupplierRequest } from './supplierRequest';
import { SupplierVettingAssessmentRecord } from './supplierVettingRequest';

export interface Opportunity {
  vettingId: string;
  requestId: string;
  orgId: string;
  enterpriseOrgId: string;
  entityType: EntityTypes.supplierVettingRequest;
  orgName: string;
  status: SupplierVettingStatus;
  assessments: {
    [key: string]: SupplierVettingAssessmentRecord;
  };
  created: number;
  lastUpdated: number;
  supplierRequest?: SupplierRequest;
  customerAvatar?: Avatar;
  enterpriseOrgName?: string;
}
